import { getEachWayTitleInfo } from "../../selection";
export const getSelectionTitleOutrightProps = (bet, selection, state) => {
    const titleProps = {
        name: selection.selectionDisplayName,
        odds: selection.displayOdds ? selection.displayOdds : state.dict.NotAvailable
    };
    if (bet.isEachWay && selection.eachWayOdds) {
        titleProps.name = `${titleProps.name} ${getEachWayTitleInfo(selection, state)}`;
    }
    return titleProps;
};
//# sourceMappingURL=getSelectionTitleOutrightProps.js.map